module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "chapter06"
    }
  }), _vm._v("TUCSON:"), _c('br'), _vm._v("STEWARD  OBSERVATORY")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("C")]), _vm._v("ochrane sat behind his desk wondering if he was sinking into paranoia. His office had only one window; it looked out on the campus, mostly concrete with a few trees offering scant shade to the students who walked or bicycled along the paved paths between buildings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He’d gotten back to Tucson late Saturday afternoon, after spending most of the day in the San Francisco airport waiting for an available flight. By the time he’d reached his apartment building just off the campus, he was exhausted. But there was something subtly wrong about his living room, something that sent a chill of anxiety up his spine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It wasn’t that the place had been ransacked; the apartment seemed as neat and orderly as when he’d left it. But he didn’t remember leaving the newspapers on the sofa like that, and he "), _c('em', [_vm._v("never")]), _vm._v(" stacked his journals in the bookcase flat on their covers, he always stood them up, spines facing out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Somebody’s been in here, he thought. Cochrane searched through the apartment. Nothing much seemed out of place, really. Nothing stolen. Not "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("that there was anything much to steal. Living room, bedroom, everything as he’d left it, pretty much. Maybe I did leave the newspapers on the sofa, he said to himself, scratching his head as he stood in the middle of the living room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He went to the kitchen and opened the dishwasher. It was empty. He distinctly remembered it held a week’s worth of dirty dishes; he’d turned it on just before he’d left.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The dishes and glasses were back in their cabinets now. The forks and spoons were in their drawer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A burglar who doesn’t take anything and leaves the place neat and tidy? Cochrane shook his head. What was he looking for? How could he get in? The front door was still locked when I got here.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Puzzled and more than a little worried about his own mental state, Cochrane went to bed. Mike’s murder is making you paranoid, he told himself. Sleep it off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He awoke early Sunday morning, the vague memory of unpleasant dreams troubling him as he showered, shaved, and then phoned Irene again. Still nothing but the damned answering machine message.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He made up his mind to go to his office. Nothing better to do, and the silent apartment gave him the creeps. The campus was quiet as he parked in his assigned slot in the cavernous parking garage. He walked slowly to the observatory building, paying no attention to the scent of orange blossoms that wafted on the cool morning breeze or the bees that hummed tirelessly from flower to flower. His leg throbbed sullenly, but exercise was good for it, according to the doctors. A pair of National Guard jets growled through the cloudless blue sky as he pushed open the building’s front door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Once in his office, Cochrane couldn’t work up the interest to boot up his computer. He simply slouched in his desk chair and swiveled around to stare out the window. He tried to phone Irene again and got the damned answering machine message once more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I should’ve stayed in Palo Alto, he said to himself. I should’ve gone to the house. She must be home. Maybe I could’ve gotten those cops to find her for me. Absently, he dipped a finger into his shirt pocket, then realized he’d left the card Sergeant Purvis had given him at his apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Then a new thought hit him. Maybe they killed her, too! Maybe she’s lying dead in their house. The SUV was parked out on the driveway. Jesus!")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He picked up the phone on his desk and punched out Mike’s home number again. The phone rang once, twice…")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Dr. Cochrane?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("He looked up. A young woman was standing in his office doorway. No student, he immediately realized. Too well dressed. She was wearing a tailored white blouse and a midthigh skirt of deep green. Her face was oval, with lustrous dark hair pulled back tightly. Green eyes, almond-shaped, almost Oriental. Good figure. Nice legs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She took a step into the tiny office and smiled at him. “You are Dr. Cochrane? Paul Cochrane?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He put the phone back into its cradle. “Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She took in the office with a single sweeping glance: the bookcase filled with journals and reports, the cluttered desk, the full-color poster of the Eagle Nebula’s breathtaking clouds where new stars are born. With a single little nod, as if confirming her expectations, she came fully into the office and sat pertly on one of the two plastic chairs in front of Cochrane’s desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’m Elena Sandoval,” she said, her voice a throaty mezzo. “I’m with the Department of Justice.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Cochrane blinked. “This has something to do with my brother?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Sandoval smiled slightly. It made both cheeks dimple.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’ve been trying to reach his wife,” Cochrane said. “His widow, I mean.” It sounded stupid to him and he thought he’d made a fool of himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Mrs. Cochrane’s at home, but she’s not taking calls. This has been something of a shock to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Cochrane nodded. “Me, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I suppose so. Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What’s Washington doing in this? Why are you involved?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Actually, it’s the Department of Homeland Security who’s interested in your brother’s murder. I’m just a local field agent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Homeland Security?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Your brother’s office was ransacked, either just before or just after he was killed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Ransacked?” Cochrane knew he was making an ass of himself, but he couldn’t think of anything else to say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Did your brother confide in you? Did he tell you anything about the work he was doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Mike’s a biologist, for chrissake! He wasn’t involved in anything dangerous.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Are you certain of that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“He worked with algae and cyanobacteria—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Cyano…?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("“Cyanobacteria,” Cochrane repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That sounds ominous.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He didn’t know whether to laugh or scowl at her ignorance. “They’re harmless bacteria that produce oxygen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“They’re not dangerous, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Cochrane shook his head. “They’re on our side.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Sandoval tilted her head slightly to one side, as if trying to determine if he was telling the truth. Cochrane realized she was very pretty, beautiful even.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Someone murdered your brother for a reason. I think it has something to do with his research.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Mike said he’d hit on something that would make him rich, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Something? What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“He wouldn’t tell me. Made me go out to Palo Alto to see for myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“And?” she asked eagerly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Cochrane felt his insides go hollow. “I never saw him. The receptionist wouldn’t let me in. He was murdered while I was in the building’s lobby.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She pursed her lips, disappointed. “So you didn’t get to see what he was working on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No. But you should be able to check it out on his computer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“The laptop computer he worked on is missing. Stolen, we presume. His office was thoroughly looted of any paperwork that might have held his notes, his references, anything pertaining to his work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What the hell were they after?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I was hoping you would know,” said Sandoval.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Cochrane didn’t know what to say. Then his cell phone began playing Mozart. He pulled it out of his shirt pocket, flicked it open, and put it to his ear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Hello.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Paul, it’s me.” He instantly recognized the voice of his brother’s widow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Irene! Are you okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“He’s dead, Paul. Somebody killed Mike.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Glancing at Sandoval, who turned away slightly and pointedly stared out the window, Cochrane said, “I know. I was there when it happened. I went to your house.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“The police told me. I should have phoned you earlier, Paul, but I couldn’t. I just couldn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He could hear the tears in her voice. “It’s okay, Irene. I was starting to worry about you, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("“I’m fine. Well, not really, but I’m all right. I got home from the school and there were a pair of police detectives on the front steps. That’s how I found out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I must have just missed you,” Cochrane said. Sandoval turned in her chair and studied the spines of the "), _c('em', [_vm._v("Astrophysical Journals")]), _vm._v(" on the top shelf of his bookcase.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“My carpool dropped me off around five-thirty. We had a teachers’ meeting after classes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You don’t need to give me an alibi, Cochrane thought. Aloud, he said, “Lousy thing to come home to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Irene sighed heavily and Cochrane realized she must be struggling to hold herself together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’ll come out there tomorrow,” he said. “I’ll help with the funeral arrangements and all that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Oh, Paul, I’d appreciate that so much! I just can’t seem to think straight for two minutes in a row. I’m such a mess.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’ll be there, Irene. Tomorrow. Soon’s I can make it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Thank you, Paul. Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“See you tomorrow, then.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Tomorrow. Yes. Goodbye, Paul.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Goodbye.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He clicked the phone shut. Sandoval focused her green eyes on him. “Would you mind if I went with you? Perhaps your brother kept some records or files at home.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Go with me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It’s important that we discover what he was working on. Whatever it was, it got him killed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I can’t believe that—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Please, Dr. Cochrane,” she said, her green eyes pleading. “Let me go with you. Please. I’d be so grateful.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Cochrane shrugged. “Okay, I guess.” He found himself thinking, Fly out there with this good-looking woman? Sure, why the hell not?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2ca60b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter06.vue
// module id = 105
// module chunks = 0